import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import "./style.scss";
import orderStore from "../../stores/order";
import menuStore from "../../stores/menu";
import {hideLoader, showLoader} from "../../helpers/ComponentHelper";

const FooterForInfoCombination = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const goBack = () => {
        menuStore.changeMenuItem();
        navigate("/menu");
    }

    const goToStart = async () => {
        await orderStore.cancelOrder();
        navigate("/");
    }

    const addToOrder = async () => {
        if (orderStore.currentCombinationOrderLine) {
            const isOrderEdit = orderStore.editComboId !== "";
            showLoader();
            const r = await orderStore.addCombinationToOrder(orderStore.currentCombinationOrderLine);
            hideLoader();

            if (menuStore.returnToScanArticle) {
                navigate("/scanArticle");
                return;
            }

            if (r)
                navigate(isOrderEdit ? "/order" : "/recommendations");
        }
    }

    return <>
        <div className="FooterSpace" />
        <div className="FooterForInfoCombination">
            <div className="buttons">
                <div className="button back" onClick={goBack}>{t("back")}</div>
                <div className="button dark" onClick={addToOrder}>{t("addToOrder")}</div>
            </div>
            <div className="startOverContainer">
                <div className="button startOver noBorder" onClick={goToStart}>{t("startOver")}</div>
            </div>
        </div>
    </>
}

export default FooterForInfoCombination;
